import { ErrorResponse, FgStatusEnum, GradeInvStatusEnum, JobCompletedEnum, JobStatusEnum, OperationTypeEnum, ShiftsEnum } from '@gtpl/shared-models/common-models';
import { AssignGradingResponse, CommonResponse, GradeLotInvModel, GradeLotInvResponse, GradeLotNoModel, GradeLotNoResponse, GradingDashboardModel, GradingDashboardResponse, GradingInventoryModel, GradingInventoryResponse, GradingModel, LotCodeDropDown, LotCodesResponse, YieldReportModel, CountQuantityModel } from '@gtpl/shared-models/production-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { WorkStations } from '../workstations/workstations.entity';
import { AssignSoDto } from './dto/assign-so.dto';
import { GradeLotNoRequest } from './dto/grade-lot-no.request';
import { GradeReportingDto } from './dto/grade-reporting.dto';
import { ProductionInventoryData } from './dto/production-inventory.dto';
import { UnitRequest } from './dto/unit.id.request';
import { GradeInventoryLog } from './entities/grade-inventory-log';
import { GradeInventory } from './entities/grade-inventory.entity';
import { ProductionInventory } from './entities/production-inventory.entity';
import { ProductionLog } from './entities/production-log.entity';
import { ProductionLogService } from './production-log.service';
import { GradeInventoryLogRepository } from './repositories/grade-inventory-log.repository';
import { GradeInventoryRepository } from './repositories/grade-inventory.repository';
import { LotCodeOpsRepository } from './repositories/lot-code.repository';
import { ProductionInventoryRepository } from './repositories/production-inventory.repository';
import { ProductionLogRepository } from './repositories/production-log.repository';
import { WorkstationsService } from '../workstations/workstations.service';
import { WorkstationRequest } from '../workstations/dto/workstation.request';
import { NODATA } from 'dns';
import { VariantOperationsService } from '../variant-operations/variant-operations.service';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { VariantNextOpModel } from '../variant-operations/dto/variant-next-op.model';
import { getManager, In, IsNull, MoreThan, Not } from 'typeorm';
import { UnitcodeService } from '@gtpl/shared-services/masters';
import { IndentService } from '@gtpl/shared-services/raw-material-procurement';
import { FactoriesInput } from '@gtpl/shared-models/sale-management';
import appSettings from 'apps/services/config';
import { PlantIdRequest, UnitTypeEnum } from '@gtpl/shared-models/masters';
import { IsNotIn } from 'class-validator';
@Injectable()
export class GradeInventoryService {
    constructor(@InjectRepository(ProductionInventoryRepository)
    private inventoryRepository: ProductionInventoryRepository,
    @InjectRepository(GradeInventoryRepository)
    private gradeInventoryRepository: GradeInventoryRepository,
    @InjectRepository(LotCodeOpsRepository)
    private lotCodeOpsRepository: LotCodeOpsRepository,
    @InjectRepository(ProductionLogRepository)
    private logRepository: ProductionLogRepository,
    private unitCodesService: UnitcodeService,
    private workstationService: WorkstationsService,    
    private variantOperationService: VariantOperationsService,
    private saleService: SaleOrderService,
    private indentService: IndentService){ }
    

    async assignGradingOperation(inputReq: ProductionInventoryData): Promise<AssignGradingResponse> {
        const manager = new GenericTransactionManager();
        try {
            const result =await this.unitCodesService.getPlantDetailsById(new PlantIdRequest(inputReq.plantId))
            let columnName ;
            let productionInventoryData
            if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
                columnName = 'subPlantId'
                productionInventoryData = await this.inventoryRepository.findOne({ where: { lotNumber: inputReq.lotNumber, saleOrderId: inputReq.saleOrderId, saleOrderItemId: inputReq.saleOrderItemId, operation: OperationTypeEnum.GRADING, subPlantId: inputReq.plantId } });
            }else{
                columnName = 'plantId'
                productionInventoryData = await this.inventoryRepository.findOne({ where: { lotNumber: inputReq.lotNumber, saleOrderId: inputReq.saleOrderId, saleOrderItemId: inputReq.saleOrderItemId, operation: OperationTypeEnum.GRADING, plantId: inputReq.plantId,subPlantId:0 } });
            }


            let prodInvResponse;
            let productioninvId
            inputReq.ipBoxes = inputReq.boxes;
            inputReq.wipQuantity = inputReq.physicalQuantity;
            inputReq.operation = OperationTypeEnum.GRADING;
            inputReq.subLotNumber = inputReq.lotNumber;
            await manager.startTransaction();
            if (productionInventoryData) {
                prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryQuantity(inputReq,columnName);
                productioninvId = productionInventoryData.productionInventoryId
            } else {
                const prodInv = new ProductionInventory();
                prodInv.lotNumber = inputReq.lotNumber;
                prodInv.createdUser = inputReq.createdUser;
                prodInv.subLotNumber = inputReq.lotNumber;
                prodInv.saleOrderId = inputReq.saleOrderId;
                prodInv.saleOrderItemId = inputReq.saleOrderItemId;
                prodInv.operation = OperationTypeEnum.GRADING;
                // prodInv.nextOperation = OperationTypeEnum.VALUE_ADDITION;
                prodInv.wipQuantity = inputReq.physicalQuantity;
                prodInv.inputGrade = inputReq.inputGrade;
                prodInv.boxes = inputReq.boxes;
                if(result.data.plantType == UnitTypeEnum.PLANT){
                    prodInv.subPlantId = 0;
                    prodInv.plantId = inputReq.plantId;
                }
                if(result.data.plantType == UnitTypeEnum.SUB_PLANT){
                    prodInv.subPlantId = inputReq.plantId;
                    prodInv.plantId = inputReq.mainPlantId;

                }
                // prodInv.plantId = inputReq.plantId;
                // if (inputReq.subPlantId) {
                //     prodInv.subPlantId = inputReq.subPlantId;
                // }
                prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).save(prodInv);
                productioninvId = prodInvResponse.productionInventoryId
            }
            if (prodInvResponse) {
                
                const productionLogObj = new ProductionLog();
                productionLogObj.lotNumber = inputReq.lotNumber;
                productionLogObj.subLotNumber = inputReq.lotNumber;
                productionLogObj.saleOrderId = inputReq.saleOrderId;
                productionLogObj.saleOrderItemId = inputReq.saleOrderItemId;
                productionLogObj.operationType = OperationTypeEnum.GRADING;
                // job number generation 
                let today = new Date();
                let CurrentYear = today.getFullYear();
                let CurrentMonth = today.getMonth();
                let fromDate = 0;
                let toDate = 0;
                let totalRecords = await (await this.logRepository.find({where:{operationType:OperationTypeEnum.GRADING}})).length;
                    if ((CurrentMonth+1) < 4) {
                        fromDate = (CurrentYear-1);
                        toDate = (CurrentYear);
                    } else {
                        fromDate = (CurrentYear);
                        toDate = (CurrentYear + 1);
                    }

                totalRecords = totalRecords + 1;

                var refNo = totalRecords + "";
                while (refNo.length < 4) refNo = "0" + refNo;

                const GradingJobNo = "Grading/" + (fromDate.toString().substr(-2))+"-"+(toDate.toString().substr(-2)) + "/" + refNo;

                productionLogObj.jobNumber = GradingJobNo;
                // productionLogObj.plantId = inputReq.plantId;
                // if (inputReq.subPlantId) {
                    //     productionLogObj.subPlantId = inputReq.subPlantId;
                    // }
                //subplant wise grading operation logic
                if(result.data.plantType == UnitTypeEnum.PLANT){
                    productionLogObj.subPlantId = 0;
                    productionLogObj.plantId = inputReq.plantId;
                }
                if(result.data.plantType == UnitTypeEnum.SUB_PLANT){
                    productionLogObj.subPlantId = inputReq.plantId;
                    productionLogObj.plantId = inputReq.mainPlantId;
                }
                productionLogObj.workStationType = inputReq.workStationType;
                productionLogObj.workstation = new WorkStations();
                productionLogObj.workstation.workstationId = inputReq.workstation;
                productionLogObj.jobStatus = JobCompletedEnum.NO;
                productionLogObj.inputGrade = inputReq.inputGrade;
                productionLogObj.inputQuantity = inputReq.physicalQuantity;
                productionLogObj.inputBoxes = inputReq.boxes;
                productionLogObj.assignedUser = inputReq.createdUser;//need to get assigned user
                productionLogObj.shift = inputReq.shift;
                productionLogObj.createdUser = inputReq.createdUser;
                productionLogObj.prodInvId = productioninvId;
                productionLogObj.assignedTime = inputReq.assignedTime;
                const saveProdLog = await manager.getCustomRepository(ProductionLogRepository).save(productionLogObj);
                const updatePrevOPQty = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryIssuedQuantity(inputReq.lotNumber,inputReq.lotNumber,inputReq.saleOrderId,inputReq.saleOrderItemId,inputReq.productionInventoryId,inputReq.plantId,inputReq.physicalQuantity);
                if (saveProdLog && updatePrevOPQty) {
                    manager.completeTransaction();
                    return new AssignGradingResponse(true, 5555, 'Work station allocated and material assigned to grading', true)
                } else {
                    await manager.releaseTransaction();
                    return new AssignGradingResponse(false, 9999, 'some thing went wrong', false)
                }
            }else{
                await manager.releaseTransaction();
                throw new ErrorResponse(9999, 'Failed To allocate to workstation')
            }

        } catch (error) {
            await manager.releaseTransaction();
            throw error;
        }
    }


    /**
     * This service will get lot level count,weight and grade counts and boxes
     * @param inputReq 
     */
    async getLotLevelInfoForGrading(inputReq: GradeLotNoRequest): Promise<GradeLotNoResponse> {
        let count = 0;
        let saleOrderNumber = '';
        let currentWeight = 0;
        let wipWeight = 0;
        let prevOpWeight = 0;
        let mainPlantId = 0;
        const gradeCounts:GradingModel[] = [];    
        let rmInvResult   
        // get lot head on count
        //sub plant wise data fetching logic
        const result =await this.unitCodesService.getPlantDetailsById(new PlantIdRequest(inputReq.plantId))
        // if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
        //     rmInvResult = await this.lotCodeOpsRepository.findOne({select:["count","saleOrderId","saleOrderItemId"],where:{lotNumber: inputReq.lotNo}});
        // }else{
            rmInvResult = await this.lotCodeOpsRepository.findOne({select:["count","saleOrderId","saleOrderItemId"],where:{lotNumber: inputReq.lotNo}});
            console.log(rmInvResult,'rmInvResult')
        // }
        if(rmInvResult){
            count = rmInvResult.count;
            saleOrderNumber = await (await this.saleService.getSaleOrderDataForSoId({saleOrderId: rmInvResult.saleOrderId})).saleOrderNumber;
        }
        // get production inventory details
        let prodInvRecord
        let prevOpWeigntData
        if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
            prodInvRecord = await this.inventoryRepository.findOne({select:["wipQuantity","plantId"],where:{
                lotNumber:inputReq.lotNo,saleOrderId:rmInvResult.saleOrderId,saleOrderItemId:rmInvResult.saleOrderItemId,operation:OperationTypeEnum.GRADING,subPlantId:inputReq.plantId
            }});
            prevOpWeigntData = await this.inventoryRepository.findOne({select:["issuedQuantity","plantId"],where:{
                lotNumber:inputReq.lotNo,saleOrderId:rmInvResult.saleOrderId,saleOrderItemId:rmInvResult.saleOrderItemId,nextOperation:OperationTypeEnum.GRADING,subPlantId:inputReq.plantId
            }});
        }else{
            prodInvRecord = await this.inventoryRepository.findOne({select:["wipQuantity","plantId"],where:{
                lotNumber:inputReq.lotNo,saleOrderId:rmInvResult.saleOrderId,saleOrderItemId:rmInvResult.saleOrderItemId,operation:OperationTypeEnum.GRADING,plantId:inputReq.plantId,subPlantId:0
            }});
            prevOpWeigntData = await this.inventoryRepository.findOne({select:["issuedQuantity","plantId"],where:{
                lotNumber:inputReq.lotNo,saleOrderId:rmInvResult.saleOrderId,saleOrderItemId:rmInvResult.saleOrderItemId,nextOperation:OperationTypeEnum.GRADING,plantId:inputReq.plantId,subPlantId:0
            }});
        }

        if(prodInvRecord){
            wipWeight = prodInvRecord.wipQuantity;
            prevOpWeight = prevOpWeigntData.issuedQuantity;
            mainPlantId = prodInvRecord.plantId
        }

        let prodInvLogRecord
        if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
            prodInvLogRecord = await this.logRepository.createQueryBuilder('prod_log')
            .select('workstation_type,workstation_id')
            .leftJoin('prod_log.workstation','workstation')
            .where(`prod_log.lot_number='${inputReq.lotNo}' and sale_order_id=${rmInvResult.saleOrderId} and sale_order_item_id=${rmInvResult.saleOrderItemId} and operation='${OperationTypeEnum.GRADING}'  and sub_plant_id=${inputReq.plantId} and prod_log.workstation is not null`)
            .getRawOne();
        }else{
            prodInvLogRecord = await this.logRepository.createQueryBuilder('prod_log')
            .select('workstation_type,workstation_id')
            .leftJoin('prod_log.workstation','workstation')
            .where(`prod_log.lot_number='${inputReq.lotNo}' and sale_order_id=${rmInvResult.saleOrderId} and sale_order_item_id=${rmInvResult.saleOrderItemId} and operation='${OperationTypeEnum.GRADING}'  and plant_id=${inputReq.plantId} and sub_plant_id = 0 and prod_log.workstation is not null`)
            .getRawOne();
        }

        // get lot level grade head less counts and boxes and its weight
        let gradeInventoryResult
        if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
            gradeInventoryResult = await this.gradeInventoryRepository.find({select:["grade","boxes","quantity","gradeInvId"],where:{subPlantId: inputReq.plantId,lotNumber: inputReq.lotNo}});
        }else{
            gradeInventoryResult = await this.gradeInventoryRepository.find({select:["grade","boxes","quantity","gradeInvId"],where:{plantId: inputReq.plantId,subPlantId:0,lotNumber: inputReq.lotNo}});
        }
        if(gradeInventoryResult.length > 0){
            for(const gradeCount of gradeInventoryResult){
                gradeCounts.push(new GradingModel(gradeCount.grade,0,0,gradeCount.boxes,gradeCount.quantity,'',gradeCount.gradeInvId));
                currentWeight+=Number(gradeCount.quantity);
            }
        }
        return new GradeLotNoResponse(true,10000,'Lot Info Retrieved Successfully',new GradeLotNoModel(count,currentWeight.toString(),gradeCounts,saleOrderNumber,prodInvLogRecord?.workstation_type,prodInvLogRecord?.workstation_id,prevOpWeight,mainPlantId));
    }

    /**
     * save data into grade inv log and grade inventory tables
     * @param inputReq 
     */
    async saveCountInGradeInventory(inputReq: GradeReportingDto): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        const result =await this.unitCodesService.getPlantDetailsById(new PlantIdRequest(inputReq.plantId))
        const inv:GradeInventory[] = [];
        const invLog:GradeInventoryLog[] = [];
        if(inputReq.grades.length === 0) {
            throw new ErrorResponse(10000,'Count ann boxes should not be empty');
        }        
        inputReq.grades.map(count => {
            if(count.boxes>0){
                const gradeInvLog = new GradeInventoryLog();
                //plant and subplant wise data saving
                if(result.data.plantType == UnitTypeEnum.PLANT){
                    gradeInvLog.subPlantId = 0;
                    gradeInvLog.plantId = inputReq.plantId;
                }
                if(result.data.plantType == UnitTypeEnum.SUB_PLANT){
                    gradeInvLog.subPlantId = inputReq.plantId;
                    gradeInvLog.plantId = inputReq.mainPlantId;

                }
                // gradeInvLog.plantId = inputReq.plantId;
                gradeInvLog.shift = ShiftsEnum[inputReq.shift];
                gradeInvLog.workStationType = inputReq.workstationType;
                gradeInvLog.workstation = inputReq.workstation;
                gradeInvLog.lotNumber = inputReq.lotNo;
                gradeInvLog.grade = count.grade;
                gradeInvLog.boxes = count.boxes;
                gradeInvLog.createdUser = inputReq.createdUser;
                gradeInvLog.quantity = count.quantity;
                gradeInvLog.quantityType = GradeInvStatusEnum.REPORTED;
                invLog.push(gradeInvLog);
            }            
        });
        await manager.startTransaction();
        const gradeInvLog:GradeInventoryLog[] = await manager.getCustomRepository(GradeInventoryLogRepository).save(invLog);
        if(gradeInvLog.length === 0) { 
            await manager.releaseTransaction();    
            throw new ErrorResponse(10000,'Operation reporting failed/add boxes and grade to report');
        }
        for(const logRecord of gradeInvLog){
            const gradeInv = await this.gradeInventoryRepository.findOne({lotNumber:logRecord.lotNumber,grade:logRecord.grade});
            if(gradeInv) {
                gradeInv.boxes += logRecord.boxes;
                gradeInv.quantity = Number(gradeInv.quantity)+Number(logRecord.quantity);
                gradeInv.updatedUser = inputReq.createdUser; 
                gradeInv.plannedSoNumber = inputReq.soNumber;
                inv.push(gradeInv);
            } else {
                const gradeInvObj = new GradeInventory();
                //plnat and subplant wise data saving
                if(result.data.plantType == UnitTypeEnum.PLANT){
                    gradeInvObj.subPlantId = 0;
                    gradeInvObj.plantId = inputReq.plantId;
                }
                if(result.data.plantType == UnitTypeEnum.SUB_PLANT){
                    gradeInvObj.subPlantId = inputReq.plantId;
                    gradeInvObj.plantId = inputReq.mainPlantId;

                }
                // gradeInvObj.plantId = inputReq.plantId;
                gradeInvObj.lotNumber = inputReq.lotNo;
                gradeInvObj.grade = logRecord.grade;
                gradeInvObj.boxes = logRecord.boxes;
                gradeInvObj.quantity = logRecord.quantity;
                gradeInvObj.plannedSoNumber = inputReq.soNumber;
                gradeInvObj.createdUser = inputReq.createdUser; 
                inv.push(gradeInvObj);
            }
        }

        await manager.getCustomRepository(GradeInventoryRepository).save(inv);
        await manager.completeTransaction();
        return new CommonResponse(true,10000,'Operation reported Successfully',true);
    }

    async getAllGrnItemS():Promise<CommonResponse>{
        const manager = getManager();
        const quuery='SELECT remarks as plantLotNumber,lot_number as lotNumber FROM erpx_dev_rm_procurement.grn_items'
        const result = await manager.query(quuery)
        if(result){
            return new CommonResponse(true,1,'dataa',result)
        }else{
            return new CommonResponse(false,0,'not found',[])
        }
    }



     async getLotLevelGradingInventory(inputReq: UnitRequest): Promise<GradeLotInvResponse> {
        // const gradeInv = await this.gradeInventoryRepository.find({plantId: inputReq.unitId});
        // if(gradeInv.length === 0) {
        //     throw new ErrorResponse(10000,'Grading Inventory not found')
        // }
        // const lotGradeInvRecords:GradeLotInvModel[] = [];
        // for(const count of gradeInv) {
        //     lotGradeInvRecords.push(new GradeLotInvModel(count.lotNumber,count.grade,count.quantity,count.issuedQuantity,count.plannedSoNumber));
        // }
        let data1 =[]
                try{
                    const grnItemData = await this.getAllGrnItemS()
                    const grnItemDataeMap = new Map<string, string>();
                    grnItemData.data.forEach(loc => grnItemDataeMap.set(loc.lotNumber, loc.plantLotNumber))
                    const manager = getManager();
                    let query
            const result =await this.unitCodesService.getPlantDetailsById(new PlantIdRequest(inputReq.unitId))
             query=' SELECT u.unit_name as subplantName,uc.unit_name as plantName,grade_inv_id AS GradeInventoryId,g. plant_id AS plantId,g.sub_plant_id AS subplantId, g.lot_number AS lotNumber, g.lot_number AS lotNo,g.grade AS count, g.boxes AS boxes,g.quantity AS quantity,g.issued_quantity AS assignedQty,g.planned_so_number AS plannedSoNumber, sd.po_number AS poNumber,s.sale_order_id as saleOrderId,g.boxes,g.issued_boxes as assignedBoxes,soi.po_number as assignedSO FROM '+appSettings.production_db+'.grade_inventory g  LEFT JOIN '+appSettings.sales_db+'.sale_order s ON g.planned_so_number=s.sale_order_no LEFT JOIN '+appSettings.sales_db+'.so_invoice_details sd ON sd.sale_order_id=s.sale_order_id  left join '+appSettings.masters_db+'.unitcodes uc on uc.unit_code_id=g.plant_id LEFT JOIN '+appSettings.masters_db+'.unitcodes u on u.unit_code_id=g.sub_plant_id  LEFT JOIN '+appSettings.sales_db+'.so_invoice_details soi ON soi.sale_order_id=s.sale_order_id WHERE grade_inv_id > 0 and' 
            //  left join '+appSettings.production_db+'.production_inventory pi on pi.lot_number = g.lot_number and pi.output_grade = g.grade and pi.plant_id = g.plant_id and pi.sub_plant_id = g.sub_plant_id and pi.operation = "'+OperationTypeEnum.GRADING+'" ( production join removed loading issue resolved)
             if(result.data.plantType == UnitTypeEnum.SUB_PLANT){
             query = query +' g.sub_plant_id='+inputReq.unitId+''
             }else{
                query = query +' g.plant_id ='+inputReq.unitId+' '
             }
            const data=await manager.query(query)      
            for(const record of data){
                let plantLot
                plantLot = grnItemDataeMap.get(record.lotNumber)
                if(plantLot == null ){
                    plantLot = record.lotNumber
                }else{
                    plantLot = record.lotNumber+'-'+grnItemDataeMap.get(record.lotNumber)
                }
                data1.push({
                    subplantName:record.subplantName,
                    plantName:record.plantName,
                    GradeInventoryId:record.GradeInventoryId,
                    plantId:record.plantId,
                    subplantId:record.subplantId,
                    lotNumber:record.lotNumber,
                    lotNo:record.lotNo,
                    count:record.count,
                    boxes:record.boxes,
                    quantity:record.quantity,
                    assignedQty:record.assignedQty,
                    plannedSoNumber:record.plannedSoNumber,
                    poNumber:record.poNumber,
                    saleOrderId:record.saleOrderId,
                    assignedBoxes:record.assignedBoxes,
                    assignedSO:record.assignedSO,
                    lotnplantlot:plantLot
                })
            }
        
            if(data1.length > 0){
                return new GradeLotInvResponse(true,1001,"Grading Inventory Retrieved Successfully",data1);
              }
              else{
                return new GradeLotInvResponse(false,1010,"No data found. ",data1);
              }
        }
        catch(err){
            return err
          }
        // return new GradeLotInvResponse(true,10000,'Grading Inventory Retrieved Successfully',lotGradeInvRecords);
    }


    /**
     * assign count to SO
     * @param inputReq 
     */
     async assignCountToSO(inputReq: AssignSoDto): Promise<CommonResponse> { 
        const manager = new GenericTransactionManager();   
        try{
            //check if same SO and Lot existed with another count
            const existingGradesdata = await this.inventoryRepository.find({where:{lotNumber:inputReq.lotNo,saleOrderId:inputReq.soNumber,saleOrderItemId:inputReq.soItemNumber,operation:OperationTypeEnum.GRADING,inputGrade:Not(In([0,inputReq.count]))}})
            console.log(existingGradesdata,'existingGradesdata')
            if(existingGradesdata.length > 0){
                throw new ErrorResponse(10000,'Same Lot should not contain different grdaes with Same Saleorder');
            }
           
            // Getting variant information for so item id
            const variantInfo = await this.saleService.getVarientInfoForSoItem({saleOrderItemId: inputReq.soItemNumber});
            if(!variantInfo.status){
                throw new ErrorResponse(10000,'Variant information not found');
            }       
            // get next operation for current operation by varaint id
            const nextOperation = await this.variantOperationService.getNextOperationForVariantId(new VariantNextOpModel(OperationTypeEnum.GRADING,variantInfo.data.variantId,inputReq.plantId));
            await manager.startTransaction();
            // insert into garding inv log
            const gradeInvLogObj = await manager.getCustomRepository(GradeInventoryLogRepository).findOne({lotNumber:inputReq.lotNo,grade:inputReq.count,quantityType: GradeInvStatusEnum.REPORTED });

            //getting workstation capacity        
            const capacityResp = await this.workstationService.getCapacityForPlantAndWorkstation(new WorkstationRequest(gradeInvLogObj.workstation,inputReq.plantId));

            const capacity = capacityResp.data;
            const boxes = Math.ceil(inputReq.quantity/capacity);

            const gradeInvLog = new GradeInventoryLog();
            //plant and subplant wise data saving

            gradeInvLog.plantId = gradeInvLogObj.plantId;
            gradeInvLog.subPlantId = gradeInvLogObj.subPlantId;
            gradeInvLog.shift = gradeInvLogObj.shift;
            gradeInvLog.workStationType = gradeInvLogObj.workStationType;
            gradeInvLog.workstation = gradeInvLogObj.workstation;
            gradeInvLog.lotNumber = inputReq.lotNo;
            gradeInvLog.grade = inputReq.count;
            gradeInvLog.boxes = inputReq.boxes;
            gradeInvLog.createdUser = inputReq.createdUser;
            gradeInvLog.quantity = inputReq.quantity;
            gradeInvLog.quantityType = GradeInvStatusEnum.ASSIGNED;
            gradeInvLog.saleOrderId = inputReq.soNumber;
            gradeInvLog.saleOrderItemId = inputReq.soItemNumber;
            await manager.getCustomRepository(GradeInventoryLogRepository).save(gradeInvLog);
            // update grading inv
            const gradeInvObj = await manager.getCustomRepository(GradeInventoryRepository).findOne({lotNumber:inputReq.lotNo,grade:inputReq.count});
            gradeInvObj.issuedQuantity = Number(gradeInvObj.issuedQuantity) + Number(inputReq.quantity);
            gradeInvObj.issuedBoxes = Number(gradeInvObj.issuedBoxes) + Number(inputReq.boxes);
            gradeInvObj.updatedUser = inputReq.createdUser;
            if(Number(gradeInvObj.issuedQuantity)>Number(gradeInvObj.quantity) || Number(gradeInvObj.issuedQuantity)>Number(gradeInvObj.quantity)){
                await manager.releaseTransaction();
                throw new ErrorResponse(10000,'Issued quantity cannot exceed original quantity');
            }        
            await manager.getCustomRepository(GradeInventoryRepository).save(gradeInvObj);

            // Get So Related Information
            const soInfo = await this.saleService.getPoNumberForSoId({saleOrderId:inputReq.soNumber});
            if(!soInfo && soInfo.data.saleOrderId === null){
                await manager.releaseTransaction();
                throw new ErrorResponse(10000,'Sale order not found!!!');
            }            
            const subLotNumber = inputReq.lotNo+'-'+soInfo.data.SoInvDetailsInfo.poNumber+'-'+inputReq.count+'-'+variantInfo.data.variantCode;
            const prodInvObj = await manager.getCustomRepository(ProductionInventoryRepository).findOne({lotNumber:inputReq.lotNo,saleOrderId:inputReq.soNumber,saleOrderItemId:inputReq.soItemNumber,operation:OperationTypeEnum.GRADING,plantId:inputReq.plantId,subPlantId:gradeInvLogObj.subPlantId})
            console.log(prodInvObj,'prodInvObj')
            let prodInvId
            const WIPupdate = await manager.getCustomRepository(ProductionInventoryRepository).update({lotNumber: inputReq.lotNo, saleOrderId: inputReq.plannedSoId, operation: OperationTypeEnum.GRADING, plantId: gradeInvLogObj.plantId,subPlantId:gradeInvLogObj.subPlantId},{wipQuantity: ()=>`wip_quantity-${inputReq.quantity}`})
            if(prodInvObj){
                // Update data in production inventory        
                const prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).update({lotNumber: inputReq.lotNo, saleOrderId: inputReq.soNumber, saleOrderItemId: inputReq.soItemNumber, operation: OperationTypeEnum.GRADING, plantId: gradeInvLogObj.plantId,subPlantId:gradeInvLogObj.subPlantId}, {subLotNumber:subLotNumber,nextOperation:nextOperation,inputGrade:inputReq.count,outputGrade:inputReq.count,physicalQuantity:()=>`physical_quantity+${inputReq.quantity}`,updatedUser:inputReq.createdUser,opBoxes: ()=>`op_boxes+${inputReq.boxes}`});
                prodInvId = prodInvObj.productionInventoryId
                if(!(prodInvResponse.affected)){
                    await manager.releaseTransaction();
                    throw new ErrorResponse(10000,'something went wrong in operation update');
                }
            }else{
                // create production inventory record
                const prodInv = new ProductionInventory();
                prodInv.lotNumber = inputReq.lotNo;
                prodInv.createdUser = inputReq.createdUser;
                prodInv.subLotNumber = subLotNumber;
                prodInv.saleOrderId = inputReq.soNumber;
                prodInv.saleOrderItemId = inputReq.soItemNumber;
                prodInv.operation = OperationTypeEnum.GRADING;
                prodInv.nextOperation = nextOperation;
                prodInv.inputGrade = inputReq.count;
                prodInv.outputGrade = inputReq.count;
                prodInv.physicalQuantity = inputReq.quantity;
                prodInv.boxes = 0;
                prodInv.opBoxes = inputReq.boxes;
                prodInv.plantId = gradeInvLogObj.plantId;
                prodInv.subPlantId = gradeInvLogObj.subPlantId;
                prodInv.status = FgStatusEnum.IN_PROGRESS;
                prodInv.updatedUser = inputReq.createdUser;
                const prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).save(prodInv);
                prodInvId = prodInvResponse.productionInventoryId
                if(!prodInvResponse){
                    await manager.releaseTransaction();
                    throw new ErrorResponse(10000,'something went wrong in operation update');
                }
            }
            // validate if sale order details are avaialbe or not
            const prodInvLogObj = await manager.getCustomRepository(ProductionLogRepository).find({lotNumber: inputReq.lotNo, saleOrderId: inputReq.soNumber, saleOrderItemId: inputReq.soItemNumber, operationType: OperationTypeEnum.GRADING, plantId: inputReq.plantId,jobStatus:JobCompletedEnum.NO});
           
            if(!(prodInvLogObj.length > 0)){
                

                const productionLogObj = new ProductionLog();
                productionLogObj.lotNumber = inputReq.lotNo;
                productionLogObj.subLotNumber = subLotNumber;
                productionLogObj.saleOrderId = inputReq.soNumber;
                productionLogObj.saleOrderItemId = inputReq.soItemNumber;
                productionLogObj.operationType = OperationTypeEnum.GRADING;
                // job number generation 
                const today = new Date();
                const CurrentYear = today.getFullYear();
                const CurrentMonth = today.getMonth();
                let fromDate = 0;
                let toDate = 0;
                let totalRecords = await (await this.logRepository.find({where:{operationType:OperationTypeEnum.GRADING}})).length;
                    if ((CurrentMonth+1) < 4) {
                        fromDate = (CurrentYear-1);
                        toDate = (CurrentYear);
                    } else {
                        fromDate = (CurrentYear);
                        toDate = (CurrentYear + 1);
                    }

                totalRecords = totalRecords + 1;

                let refNo = totalRecords + "";
                while (refNo.length < 4) refNo = "0" + refNo;

                const GradingJobNo = "Grading/" + (fromDate.toString().substr(-2))+"-"+(toDate.toString().substr(-2)) + "/" + refNo;

                productionLogObj.jobNumber = GradingJobNo;
                productionLogObj.plantId = gradeInvLogObj.plantId;
                productionLogObj.subPlantId = gradeInvLogObj.subPlantId;
                productionLogObj.workStationType = gradeInvLogObj.workStationType;
                productionLogObj.workstation = new WorkStations();
                productionLogObj.workstation.workstationId = gradeInvLogObj.workstation;
                productionLogObj.jobStatus = JobCompletedEnum.YES;
                productionLogObj.inputGrade = inputReq.count;
                productionLogObj.plannedGrade = inputReq.count;
                productionLogObj.actualGrade = inputReq.count;
                productionLogObj.inputQuantity = 0;
                productionLogObj.plannedOutputQuantity = inputReq.quantity;
                productionLogObj.actualOutputQuantity = inputReq.quantity;
                productionLogObj.inputBoxes = 0;
                productionLogObj.outputBoxes = inputReq.boxes;
                productionLogObj.assignedUser = inputReq.createdUser;
                productionLogObj.shift = gradeInvLogObj.shift;
                productionLogObj.createdUser = inputReq.createdUser;
                productionLogObj.prodInvId = prodInvId;
                productionLogObj.assignedTime = new Date();
                productionLogObj.reportedTime = new Date();
                productionLogObj.updatedUser = inputReq.createdUser;
                const prodLogSave = await manager.getCustomRepository(ProductionLogRepository).save(productionLogObj);
                if(!prodLogSave){
                    await manager.releaseTransaction();
                    throw new ErrorResponse(10000,'something went wrong in log update');
                }
            } else {
                console.log('yesss records')
                console.log(prodInvLogObj.length)
                // Update data in production inventory log
                // const gradeInventoryData = await this.gradeInventoryRepository.findOne()
                // let jobStatus = JobCompletedEnum.NO;
                // if(Number(prodInvLogObj.inputQuantity)===(Number(prodInvLogObj.actualOutputQuantity)+Number(inputReq.quantity))){
                    const jobStatus = JobCompletedEnum.YES;
                // }
                let prodLogUpdate
                if(prodInvLogObj.length == 1){
                console.log('lenth11')

                    prodLogUpdate = await manager.getCustomRepository(ProductionLogRepository).update({lotNumber: inputReq.lotNo, saleOrderId: inputReq.soNumber, saleOrderItemId: inputReq.soItemNumber, operationType: OperationTypeEnum.GRADING, plantId: gradeInvLogObj.plantId,subPlantId:gradeInvLogObj.subPlantId}, {subLotNumber:subLotNumber,jobStatus: jobStatus,plannedGrade:inputReq.count,actualGrade:inputReq.count,plannedOutputQuantity:inputReq.quantity,actualOutputQuantity:inputReq.quantity,outputBoxes: inputReq.boxes,reportedTime: new Date(),updatedUser:inputReq.createdUser});

                }else{
                console.log('morethan1')

                    const prodLogdataUpdate = await manager.getCustomRepository(ProductionLogRepository).update({lotNumber: inputReq.lotNo, saleOrderId: inputReq.soNumber, saleOrderItemId: inputReq.soItemNumber, operationType: OperationTypeEnum.GRADING, plantId: gradeInvLogObj.plantId,subPlantId:gradeInvLogObj.subPlantId}, {subLotNumber:subLotNumber,jobStatus: jobStatus,plannedGrade:inputReq.count,actualGrade:inputReq.count,reportedTime: new Date(),updatedUser:inputReq.createdUser});
                    if(prodLogdataUpdate.affected){
                        prodLogUpdate = await manager.getCustomRepository(ProductionLogRepository).update({productionLogId: prodInvLogObj[0].productionLogId}, {plannedOutputQuantity:inputReq.quantity,actualOutputQuantity:inputReq.quantity,outputBoxes: inputReq.boxes});
                    }else{
                        await manager.releaseTransaction();
                        throw new ErrorResponse(10000,'something went wrong in log update');
                    }
                }
                if(!(prodLogUpdate.affected)){
                    await manager.releaseTransaction();
                    throw new ErrorResponse(10000,'something went wrong in log update');
                }
        
            }
            
            await manager.completeTransaction();
            return new CommonResponse(true,10000,'Count Assigned to SO and Reported Successfully',true);
        } catch(error) {
            await manager.releaseTransaction();
            throw error;
        }
        
    }

    /**
     * get grading inventory for unit id
    */
    async getGradingInventory(inputReq: UnitRequest): Promise<GradingInventoryResponse> {
        try{
        const manager = getManager();
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+inputReq.unitId;
        const result =await manager.query(query);
        console.log(result[0].plant_type)
        let gradeinv
        if(result[0].plant_type == UnitTypeEnum.SUB_PLANT){
            gradeinv =`select CONCAT(gi.lot_number,IF(gi.remarks IS NOT NULL,'-',''),IF(gi.remarks IS NOT NULL ,gi.remarks , '')) as concatLotNum, s.sale_order_no as soNumber,si.po_number as poNumber,s.sale_order_id as saleOrderId,sub_lot_number AS subLotNo,output_grade as count,physical_quantity as quantity,issued_quantity as issuedQty,next_operation as nextOperation,p.lot_number as lotNo,p.sale_order_id as saleOrderId from `+appSettings.production_db+`.production_inventory p left join `+appSettings.sales_db+`.sale_order s on p.sale_order_id=s.sale_order_id left join `+appSettings.sales_db+`.so_invoice_details si on p.sale_order_id=si.sale_order_id left join `+appSettings.rm_procure_db +`.grn_items gi ON gi.lot_number = p.lot_number where sub_plant_id=`+inputReq.unitId+` and operation="`+OperationTypeEnum.GRADING+`" `
        }else{
            gradeinv =`select CONCAT(gi.lot_number,IF(gi.remarks IS NOT NULL,'-',''),IF(gi.remarks IS NOT NULL ,gi.remarks , '')) as concatLotNum , s.sale_order_no as soNumber,si.po_number as poNumber,s.sale_order_id as saleOrderId,sub_lot_number AS subLotNo,output_grade as count,physical_quantity as quantity,issued_quantity as issuedQty,next_operation as nextOperation,p.lot_number as lotNo,p.sale_order_id as saleOrderId from `+appSettings.production_db+`.production_inventory p left join `+appSettings.sales_db+`.sale_order s on p.sale_order_id=s.sale_order_id left join `+appSettings.sales_db+`.so_invoice_details si on p.sale_order_id=si.sale_order_id left join `+appSettings.rm_procure_db +`.grn_items gi ON gi.lot_number = p.lot_number`
//   where plant_id=`+inputReq.unitId+` and sub_plant_id =0 and operation="`+OperationTypeEnum.GRADING+`" `
        if(inputReq.unitId && inputReq.unitId != 5){
            gradeinv =gradeinv+ ` where plant_id=`+inputReq.unitId+` and sub_plant_id =0 and operation="`+OperationTypeEnum.GRADING+`"`
        }
        else{
            gradeinv =gradeinv+` and sub_plant_id =0 and operation="`+OperationTypeEnum.GRADING+`"`
        }
        }
     
     const data =await manager.query(gradeinv)
     if(data){
        return new GradingInventoryResponse(true,10000,'Grading Inventory retrieved successfully',data);

     }}catch(err){
        return err;

     }

//    const gradingInv = await this.inventoryRepository.find({select:["subLotNumber","outputGrade","physicalQuantity","issuedQuantity","nextOperation","lotNumber","saleOrderId"],where:{plantId: inputReq.unitId,operation: OperationTypeEnum.GRADING}});
//         if(gradingInv.length === 0){
//             throw new ErrorResponse(10000,'Grading Inventory not found');
//         }
//         const gradingInvs:GradingInventoryModel[] = [];
//         for(const grading of gradingInv){
//             const soData = await this.saleService.getSaleOrderFewDetailsForSoId({saleOrderId: grading.saleOrderId});
//             gradingInvs.push(new GradingInventoryModel(grading.subLotNumber,grading.outputGrade,grading.physicalQuantity,grading.issuedQuantity,soData.saleOrderNumber,grading.lotNumber,grading.nextOperation,soData.poNumber,soData.saleOrderId));
//         }
     
    }

    /**
     * get grading inventory for unit id
    */
    async getGradingDashboardData(inputReq: UnitRequest): Promise<GradingDashboardResponse> {
        const manager = getManager();
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+inputReq.unitId;
        const result =await manager.query(query);
        let gradingInvdata;    
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){        
            gradingInvdata = await this.inventoryRepository.find({select:["saleOrderItemId","outputGrade","physicalQuantity","issuedQuantity","wipQuantity"],where:{subPlantId: inputReq.unitId,operation: OperationTypeEnum.GRADING}});  
        }else{
           gradingInvdata = await this.inventoryRepository.find({select:["saleOrderItemId","outputGrade","physicalQuantity","issuedQuantity","wipQuantity"],where:{plantId: inputReq.unitId,operation: OperationTypeEnum.GRADING,subPlantId:0}});  
        }      
        const qtyToBeProcessed = await this.inventoryRepository.getQtyToBeProcessed(OperationTypeEnum.BE_HEADING, inputReq.unitId);
        let lotCount = 0;
        let qtyInProgress = 0;
        let gradingInventory = 0;
        const countMap = new Map<number,{pending:number,filled:number}>();        
        const counts = [];
        const filledQty = [];
        const pendingQty = [];
        if(gradingInvdata.length > 0){
            for(const grading of gradingInvdata){
                lotCount+=1;
                qtyInProgress+=Number(grading.wipQuantity);
                if((Number(grading.physicalQuantity) - Number(grading.issuedQuantity)) > 0){
                    gradingInventory+=Number(grading.physicalQuantity - Number(grading.issuedQuantity));
                }
                if(!countMap.has(grading.outputGrade)){
                    countMap.set(grading.outputGrade,{pending:0,filled:0});
                }
                countMap.get(grading.outputGrade).pending+=Number(grading.wipQuantity)+Number(grading.issuedQuantity);
                countMap.get(grading.outputGrade).filled+=Number(grading.physicalQuantity);
            }
            for(const[key,value] of countMap){
                console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@')
                console.log(countMap)
                counts.push(key.toString());
                filledQty.push(value.filled);
                pendingQty.push(value.pending);
            }
        }
        return new GradingDashboardResponse(true,10000,'Grading Dasboard data retrieved successfully',new GradingDashboardModel(lotCount,qtyToBeProcessed,qtyInProgress,gradingInventory,counts,pendingQty,filledQty));
    }
    async getLotNosForGrading(inputReq: UnitRequest): Promise<LotCodesResponse> {
        try{        
        const manager = getManager();
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+inputReq.unitId;
        const result =await manager.query(query);
        console.log(result[0].plant_type)
        console.log('&&&&&&&')
        let prodInv
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
             prodInv =`select pi.lot_number as lotNumber , CONCAT(g.lot_number,IF(g.remarks IS NOT NULL,'-',''),IF(g.remarks IS NOT NULL ,g.remarks , '')) as concatLotNum from `+appSettings.production_db+`.production_inventory pi LEFT JOIN `+appSettings.rm_procure_db +`.grn_items g ON g.lot_number = pi.lot_number where pi.sub_plant_id = `+inputReq.unitId+` and pi.operation ="`+OperationTypeEnum.GRADING+`" and pi.status in("`+FgStatusEnum.OPEN+`","`+FgStatusEnum.IN_PROGRESS+`") and pi.wip_quantity >0 `
        }else{
             prodInv =`select pi.lot_number as lotNumber ,CONCAT(g.lot_number,IF(g.remarks IS NOT NULL, ' - ' ,''),IF(g.remarks IS NOT NULL ,g.remarks , '')) as concatLotNum from `+appSettings.production_db+`.production_inventory pi LEFT JOIN `+appSettings.rm_procure_db +`.grn_items g ON g.lot_number = pi.lot_number where pi.plant_id = `+inputReq.unitId+` and pi.operation ="`+OperationTypeEnum.GRADING+`" and pi.status in("`+FgStatusEnum.OPEN+`","`+FgStatusEnum.IN_PROGRESS+`") and pi.wip_quantity >0 and pi.sub_plant_id =0 `
        }
        // const prodInv = await this.inventoryRepository.find({select:["lotNumber"],where:{plantId:inputReq.unitId,operation:OperationTypeEnum.GRADING,status: In([FgStatusEnum.OPEN,FgStatusEnum.IN_PROGRESS]),wipQuantity: MoreThan(0)}});
     const data = await manager.query(prodInv)
     if(data){
      const res = new LotCodesResponse(true, 1111, "Data retreived sucesssfuly", data)
      return res
     }
    }catch(err){
        return err
     }
    }

    async getYieldReportData(inputReq: UnitRequest):Promise<CommonResponse> {
        const manager = getManager()
        let query
        const yeildReportData:YieldReportModel[] = [];
        const plant='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+inputReq.unitId;
        const result =await manager.query(plant);
        if(result[0].plant_type == UnitTypeEnum.SUB_PLANT){
            query='select CONCAT(g.lot_number,IF(g.remarks IS NOT NULL, " - " ,""),IF(g.remarks IS NOT NULL ,g.remarks , "")) as concatLotNum, uc.unit_name as plantName,pi.lot_number as lotNumber from '+appSettings.production_db+'.production_inventory pi left join '+appSettings.masters_db+'.unitcodes uc on uc.unit_code_id=pi.sub_plant_id LEFT JOIN '+appSettings.rm_procure_db +'.grn_items g ON g.lot_number = pi.lot_number where operation="'+OperationTypeEnum.BE_HEADING+'" and pi.sub_plant_id='+inputReq.unitId+' and wip_quantity = 0 and (physical_quantity-issued_quantity) = 0'
       }else{
           query='select CONCAT(g.lot_number,IF(g.remarks IS NOT NULL, " - " ,""),IF(g.remarks IS NOT NULL ,g.remarks , "")) as concatLotNum, uc.unit_name as plantName,pi.lot_number as lotNumber from '+appSettings.production_db+'.production_inventory pi left join '+appSettings.masters_db+'.unitcodes uc on uc.unit_code_id=pi.plant_id LEFT JOIN '+appSettings.rm_procure_db +'.grn_items g ON g.lot_number = pi.lot_number where operation="'+OperationTypeEnum.BE_HEADING+'" and pi.plant_id='+inputReq.unitId+' and wip_quantity = 0 and (physical_quantity-issued_quantity) = 0 and pi.sub_plant_id=0'
       }
       const prodInvRecords = await manager.query(query)
        // const prodInvRecords = await this.inventoryRepository.createQueryBuilder('prod_log')
        // .select('lot_number')
        // .where(`operation='${OperationTypeEnum.BE_HEADING}' and plant_id=${inputReq.unitId} and wip_quantity = 0 and (physical_quantity-issued_quantity) = 0`)
        // .getRawMany();
        // if(prodInvRecords.length === 0){
        //     throw new ErrorResponse(10000,'Lot numbers not found');
        // }
        // const plantDataQry = `select unit_code_id as plantId,unit_name as plantName from `+appSettings.masters_db+`.unitcodes where unit_code_id = `+inputReq.unitId
        // const plantData = await manager.query(plantDataQry)
        
        // const plantObj = FactoriesInput.find((plant) => {
        //     return plant.id === inputReq.unitId;
        // });
        for(const record of prodInvRecords){
            const lotCodeOpsData = await this.lotCodeOpsRepository.findOne({select:["count","grnDate","indentId","quantity"],where:{
                lotNumber:record.lotNumber
            }});
            if(lotCodeOpsData){
                // get indent related data
                const indentData = await this.indentService.getIndentDetailsById({indentId:lotCodeOpsData.indentId});
                if(indentData.status){
                    const result = indentData.data;
                    const gradingResult = await this.gradeInventoryRepository.find({select:["grade","quantity","createdAt"],where:{lotNumber:record.lotNumber,plantId:inputReq.unitId}});
                    if(gradingResult.length>0){
                        let totalWeight = 0;
                        let avgCount = 0;
                        let gradingDate;
                        const countQtyModel:CountQuantityModel = {};
                        for(const grading of gradingResult){
                            countQtyModel[grading.grade] = grading.quantity;
                            gradingDate = grading.createdAt;
                            totalWeight+=Number(grading.quantity);
                            avgCount+=(Number(grading.grade)*Number(grading.quantity));
                        }
                        const yeildPercentage = (lotCodeOpsData.quantity)?Number(totalWeight)/Number(lotCodeOpsData.quantity):0;
                        const overallAvgCount = (totalWeight)?avgCount*2.2*yeildPercentage/Number(totalWeight):0;
                        yeildReportData.push(new YieldReportModel(result.supplierType,result.supplierCode,result.supplierName,result.indentDate,result.createdUser,record.plantName,record.lotNumber, result.expectedQty,result.expectedCount,lotCodeOpsData.grnDate,lotCodeOpsData.quantity,lotCodeOpsData.count,'','',gradingDate,Math.ceil(overallAvgCount),totalWeight,Math.ceil(yeildPercentage*100),[countQtyModel],record.concatLotNum));
                        console.log('----------------',yeildReportData)
                    }
                    
                }              
            }
        }
        
        return new CommonResponse(true,10000,'Data retrieved successfully',yeildReportData);
    }

    /**
     * This service will clear the wip for grading operation
     * @param inputReq 
     */
     async clearWip(inputReq: GradeLotNoRequest): Promise<CommonResponse> {          
        // get lot head on count
        const rmInvResult = await this.lotCodeOpsRepository.findOne({select:["count","saleOrderId","saleOrderItemId"],where:{plantId: inputReq.plantId,lotNumber: inputReq.lotNo}});
        if(!rmInvResult){
            throw new ErrorResponse(10000,'Lot number not found');
        }
        const prodInvRecord = await this.inventoryRepository.findOne({select:["productionInventoryId"],where:{
            lotNumber:inputReq.lotNo,saleOrderId:rmInvResult.saleOrderId,saleOrderItemId:rmInvResult.saleOrderItemId,operation:OperationTypeEnum.GRADING,plantId:inputReq.plantId
        }});
        if(!prodInvRecord){
            throw new ErrorResponse(10000,'Production inventory not found');
        }
        const updatedInvRecord = await this.inventoryRepository.update({lotNumber:inputReq.lotNo,saleOrderId:rmInvResult.saleOrderId,saleOrderItemId:rmInvResult.saleOrderItemId,operation:OperationTypeEnum.GRADING,plantId:inputReq.plantId},{wipQuantity:0});

        if(updatedInvRecord.affected===0){
            throw new ErrorResponse(10000,'Clearing WIP in production inventory failed');
        }

        return new CommonResponse(true,10000,'Lot Info Retrieved Successfully');
    }

    async deheadingInventotyData(req : UnitRequest):Promise<CommonResponse>{
        const manager = getManager();
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+req.unitId;
        const result =await manager.query(query);
        let dataQuery = `SELECT CONCAT(p.lot_number,IF(g.remarks IS NOT NULL,"-",""),IF(g.remarks IS NOT NULL ,g.remarks , "")) as concatLotNum, p.lot_number AS lotNumber , p.next_operation AS operation,p.issued_quantity AS qty,so.po_number AS soNumber,sc.variant_code AS variantCode FROM `+appSettings.production_db + `.production_inventory p 
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details so ON so.sale_order_id = p.sale_order_id
        LEFT JOIN ` + appSettings.sales_db + `.sale_order_items s ON s.sale_order_item_id = p.sale_order_item_id 
        LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id = s.varient_id 
        LEFT JOIN `+appSettings.rm_procure_db +`.grn_items g ON g.lot_number = p.lot_number
        WHERE p.next_operation = 'GRADING' AND status!="${FgStatusEnum.CLOSE}" `
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
            dataQuery += "AND p.sub_plant_id="+req.unitId;
          }else{
            if(req.unitId && req.unitId!=5){
                dataQuery += "AND p.plant_id="+req.unitId+' and p.sub_plant_id = 0';
            }
            else{
                dataQuery += ' and p.sub_plant_id = 0';
            }
            
          }
          const data =await manager.query(dataQuery);
          if(data.length > 0 ){
            return new CommonResponse(true,10000,'Data Retrieved Successfully',data);
          }else{
            throw new ErrorResponse(10000,'No data found');
          }
    }

}
